<template>
    <div class="mt-2 flex flex-wrap items-center gap-x-2" v-if="a && b">
        <span class="text-base text-cyan-600 font-semibold">Assimetria: </span>
        <span class="text-base text-cyan-600 font-black">{{ asymmetry || 0 }}%</span>

        <template v-if="showSymmetry">
            <span class="text-slate-300">|</span>
            <span class="text-base text-cyan-600 font-semibold">Simetria: </span>
            <span class="text-base text-cyan-600 font-black">{{ symmetry || 0 }}%</span>
        </template>

        <svg v-if="asymmetry < max" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-lime-500 bg-lime-100 w-6 h-6 rounded-full">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>

        <div class="flex gap-x-2" v-if="asymmetry >= max">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-red-500 bg-red-100 w-6 h-6 rounded-full">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>

            <span class="text-xs mt-1 text-red-400 font-semibold">Risco</span>
        </div>
    </div>
</template>

<script>

import CalcService from '../services/CalcService';
import { ref, onMounted, watch } from 'vue';

export default {
    name: 'AsymmetryView',
    props: {
        a: Number,
        b: Number,
        max: Number,
        // Simetria é o complemento da assimetria; só alguns testes pedem os dois lados da
        // conta na tela, então fica opcional para não poluir os demais.
        showSymmetry: {
            type: Boolean,
            default: false
        },
    },
    setup(props) {
        let asymmetry = ref(0);
        let symmetry = ref(0);

        onMounted(() => {
            recalculate();
        });

        function recalculate() {
            asymmetry.value = CalcService.asymmetry(props.a, props.b);
            symmetry.value = CalcService.symmetry(props.a, props.b);
        }

        watch(() => [props.a, props.b], recalculate, { immediate: true });

        return {
            asymmetry,
            symmetry
        }
    },
}
</script>